import SliderInput from './Slider';
import { useLanguage } from '../../context/LanguageContext';

export default function SliderDifficulty({ value, onChange }) {
  const { t } = useLanguage();

  return (
    <SliderInput
      description={[
        `${t('easy')}`,
        `${t('moderate')}`,
        `${t('challenging')}`,
        `${t('difficult')}`,
        `${t('veryDifficult')}`,
      ]}
      value={value}
      onChange={onChange}
    />
  );
}
